import { getFetch } from "../../utils/fetch";

async function getProject(term) {
  const data = await getFetch(`/ReportWeb/Project?term=${term}`);
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}

export { getProject };
